import React from "react";

const Description = ({ children, customClass }) => {
  return (
    <p className={`description ${customClass && customClass}`}>{children}</p>
  );
};

export default Description;
